import { render, staticRenderFns } from "./AssetDisplay.vue?vue&type=template&id=50d21f5a"
import script from "./AssetDisplay.vue?vue&type=script&lang=js"
export * from "./AssetDisplay.vue?vue&type=script&lang=js"
import style0 from "./AssetDisplay.vue?vue&type=style&index=0&id=50d21f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports